
var onSale = false;
var soldOut = false;
var priceVaries = false;
var images = [];
var firstVariant = {};
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		/* Optional */
		loadProductFirst: true,
		numberFilterTree: 2,
		filterTreeMobileStyle: 'style1'
	},
};

(function () {
	BoostPFS.inject(this);

	/************************** CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	function prepareShopifyData(data) {
		soldOut = !data.available;
		onSale = data.compare_at_price_min > data.price_min;
		priceVaries = data.price_min != data.price_max;
		images = data.images_info;
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function (e) { return e.id == Utils.getParam('variant'); });
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		return data;
	}
	/************************** END CUSTOMIZE DATA BEFORE BUILDING PRODUCT ITEM **************************/
	/************************** BUILD PRODUCT LIST **************************/
	// Build Product Grid Item

	// --- NEW FUNCTION: Wrap image and quick buy together ---
	function buildProductCardFigure(data, images) {
		const quickBuyId = 'quick-buy-' + data.id;
		const firstVariantId = (data.variants && data.variants.length) ? data.variants[0].id : '';
		let html = '<div class="product-card__figure">';
		html += buildLabels(data); 
		html += buildImage(data, images);
		if (boostPFSConfig.custom.show_quick_buy && data.available) {
			if (data.variants.length == 1) {
				html += `
					<product-form>
						<form method="post" action="/cart/add" id="product_form_${data.id}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="on_success" value="force_open_drawer">
              				<input type="hidden" name="quantity" value="1">
              				<input type="hidden" name="id" value="${data.variants[0].id}">
              				<button type="submit" class="product-card__quick-add-button">
                				<span class="sr-only">Add to cart</span>
								<svg aria-hidden="true" focusable="false" fill="none" width="12" class="icon icon-plus" viewBox="0 0 12 12">
      								<path d="M6 0v12M0 6h12" stroke="currentColor" stroke-width="1"></path>
    							</svg>
							</button>
							<input type="hidden" name="product-id" value="${data.id}">
							<input type="hidden" name="section-id" value="template--19482901250245__main">
							</form>
					</product-form>
				`;

			} else {			
				html += `
					<button type="button" aria-controls="${quickBuyId}" class="product-card__quick-add-button">
						<svg aria-hidden="true" fill="none" focusable="false" width="24" class="icon icon-shopping_bag" viewBox="0 0 24 24">
							<path d="M4.75 8.25A.75.75 0 0 0 4 9L3 19.125c0 1.418 1.207 2.625 2.625 2.625h12.75c1.418 0 2.625-1.149 2.625-2.566L20 9a.75.75 0 0 0-.75-.75H4.75Zm2.75 0v-1.5a4.5 4.5 0 0 1 4.5-4.5v0a4.5 4.5 0 0 1 4.5 4.5v1.5" stroke="currentColor" stroke-width="1" stroke-linecap="round" stroke-linejoin="round"></path>
						</svg>
					</button>
					<quick-buy-modal
						handle="${data.handle}?variant=${firstVariantId}"
						class="quick-buy-modal modal"
						id="${quickBuyId}">
					</quick-buy-modal>
				`;
			}
		}
		 
		html += '</div>';
		return html;
	}

	ProductGridItem.prototype.compileTemplate = function (data, index) {
		if (!data) data = this.data;
		if (!index) index = this.index;
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		data = prepareShopifyData(data);

		itemHtml = itemHtml.replace(/{{itemLabels}}/g, buildLabels(data));
		itemHtml = itemHtml.replace(/{{mobileRow}}/g, boostPFSConfig.custom.mobile_row);
		itemHtml = itemHtml.replace(/{{tabletRow}}/g, boostPFSConfig.custom.tablet_row);
		itemHtml = itemHtml.replace(/{{desktopRow}}/g, boostPFSConfig.custom.desktop_row);
		
		// Set item order (index + 1 to leave room for featured collections with order 0)
		itemHtml = itemHtml.replace(/{{itemOrder}}/g, index + 2);
		
		// Check if we need to inject a featured collection before this item
		var featuredHtml = '';
		if (typeof boostPFSThemeConfig !== 'undefined' && 
		    boostPFSThemeConfig.custom && 
		    boostPFSThemeConfig.custom.featured_collections && 
		    boostPFSThemeConfig.custom.featured_collections.length > 0) {
			
			var featuredCollections = boostPFSThemeConfig.custom.featured_collections;
			var filterPosition = boostPFSThemeConfig.custom.filter_position || 'drawer';
			var layoutClass = filterPosition == 'drawer' ? 'lap-and-up' : 'desk';
			var mobileRow = boostPFSThemeConfig.custom.mobile_row || '2';
			var tabletRow = boostPFSThemeConfig.custom.tablet_row || '3';
			var desktopRow = boostPFSThemeConfig.custom.desktop_row || '4';
			
			featuredCollections.forEach(function(featured) {
				// Inject featured collection if its order matches current index
				if (featured.order == index + 1) {
					featuredHtml += '<div class="Grid__Cell-assigned-featured-collection Grid__Cell 1/' + mobileRow + '--phone 1/' + tabletRow + '--tablet-and-up 1/' + desktopRow + '--' + layoutClass + '" style="order: ' + featured.order + '">';
					if (featured.image_url && featured.image_url !== 'null' && featured.image_url !== '') {
						var altText = (featured.title && featured.title !== 'null') ? featured.title : '';
						featuredHtml += '<img src="' + featured.image_url + '" alt="' + altText + '">';
					}
					featuredHtml += '<div class="featured-collection-content">';
					if (featured.title && featured.title !== 'null' && featured.title !== '') {
						featuredHtml += '<p>' + featured.title + '</p>';
					}
					if (featured.button_label && featured.button_label !== 'null' && featured.button_label !== '' && 
					    featured.button_url && featured.button_url !== 'null' && featured.button_url !== '') {
						featuredHtml += '<a href="' + featured.button_url + '"';
						if (featured.open_in_new_tab) {
							featuredHtml += ' target="_blank"';
						}
						featuredHtml += '>' + featured.button_label + '</a>';
					}
					featuredHtml += '</div></div>';
				}
			});
		}
		itemHtml = itemHtml.replace(/{{featuredCollectionHtml}}/g, featuredHtml);

		// --- Use the new wrapper for image + quick buy ---
		itemHtml = itemHtml.replace(/{{itemImages}}/g, buildProductCardFigure(data, images));

		itemHtml = itemHtml.replace(/{{itemInfo}}/g, buildInfo(data, index));

		if (typeof Integration === 'undefined' || !Integration.hascompileTemplate('reviews')) {
			itemHtml = itemHtml.replace(/{{itemReviews}}/g, '');
		}
		itemHtml = itemHtml.replace(/{{buildClassHiz}}/g, buildClassHiz());
		itemHtml = itemHtml.replace(/{{buildClass}}/g, buildClass());
		itemHtml = itemHtml.replace(/{{buildButtonSecond}}/g, buildButtonSecond());
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		if (typeof Utils.compileShopifyProductVariables == 'function') {
			itemHtml = Utils.compileShopifyProductVariables(data, itemHtml);
		}
		if (typeof Utils.compileShopifyProductMetafield == 'function') {
			itemHtml = Utils.compileShopifyProductMetafield(data, itemHtml);
		}
		return itemHtml;
	};

	/************************** END BUILD PRODUCT LIST **************************/
	/************************** BUILD PRODUCT ITEM ELEMENTS **************************/
	function buildClass() {
		return boostPFSThemeConfig.custom.filter_position == 'drawer' ? 'lap-and-up' : 'desk';
	}

	function buildClassHiz() {
		return boostPFSThemeConfig.custom.use_horizontal ? 'ProductItem--horizontal' : '';
	}

	function buildButtonSecond() {
		return boostPFSThemeConfig.custom.use_horizontal ? '<a href="{{itemUrl}}" class="ProductItem__ViewButton Button Button--secondary hidden-pocket">' + boostPFSThemeConfig.label.view_product + '</a>' : '';
	}

	function buildImage(data, images) {
		var htmlImg = '';
		if (!images) images = [];
		if (images.length == 0) {
			images.push({
				src: boostPFSConfig.general.no_image_url,
				id: data.id,
				width: 480,
				height: 480
			});
		}
		if (images.length > 0) {
			htmlImg += '<a href="{{itemUrl}}" class="ProductItem__ImageWrapper ';
			var use_natural_size = false;
			var has_alternate_image = false;
			if (boostPFSThemeConfig.custom.product_image_size == 'natural' || boostPFSThemeConfig.custom.use_horizontal) {
				use_natural_size = true;
			}
			if (boostPFSThemeConfig.custom.product_show_secondary_image && images.length > 1 && !boostPFSThemeConfig.custom.use_horizontal) {
				has_alternate_image = true;
			}
			if (has_alternate_image) {
				htmlImg += 'ProductItem__ImageWrapper--withAlternateImage';
			}
			htmlImg += '">';

			var max_width = images[0].width;
			if (boostPFSThemeConfig.custom.use_horizontal) max_width = 125;
			var withCall = use_natural_size ? 'withFallback' : boostPFSThemeConfig.custom.product_image_size;
			htmlImg += '<div class="AspectRatio AspectRatio--' + withCall + '" style="max-width: ' + max_width + 'px;';
			var aspect_ratio = images[0].width / images[0].height;
			if (use_natural_size) {
				htmlImg += 'padding-bottom: ' + (100 / aspect_ratio) + '%;';
			}
			htmlImg += ' --aspect-ratio: ' + aspect_ratio + '">';

			if (has_alternate_image && images.length > 1) {
				var sizes = '200,300,400,600,800,900,1000,1200';
				var support_size = imageSize(sizes, images[1]);
				var thumbUrl = Utils.optimizeImage(images[1]['src'], '{width}x');
				htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[1].id + '">';
			}

			var sizes_main = '200,400,600,700,800,900,1000,1200';
			var support_size = imageSize(sizes_main, images[0]);
			var thumbUrl_main = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '{width}x') : boostPFSConfig.general.no_image_url;
			htmlImg += '<img class="ProductItem__Image Image--lazyLoad Image--fadeIn" data-src="' + thumbUrl_main + '" data-widths="[' + support_size + ']" data-sizes="auto" alt="' + data.title + '" data-image-id="' + images[0].id + '">';
			htmlImg += '<span class="Image__Loader"></span>';
			htmlImg += '<noscript>';
			htmlImg += '<img class="ProductItem__Image ProductItem__Image--alternate" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '<img class="ProductItem__Image" src="' + Utils.optimizeImage(images[0]['src'], '600x') + '" alt="' + data.title + '">';
			htmlImg += '</noscript>';

			var tags = data.tags;
			console.log(data)
			if (tags.length) {
				for (var k = 0; k < tags.length; k++) {
					var tag = tags[k];
					if (tag.indexOf('flag-bundle-deals:') != -1) {
						htmlImg += ' <div class="product-tag"><span class="product-tag--bundle-deals">' + tag.split('flag-bundle-deals:')[1] + '</span></div>';
						break;
					} else if (tag.indexOf('flag-instore') != -1) {
						htmlImg += ' <div class="product-tag"><span class="product-tag--instore-only">INSTORE ONLY</span></div>';
						break;
					} else if (tag.indexOf('flag-default:') != -1) {
						htmlImg += ' <div class="product-tag"><span class="product-tag--default">' + tag.split('flag-default:')[1] + '</span></div>';
						break;
					}
				}
			}
			htmlImg += '</div>';
			htmlImg += '</a>';
		}
		return htmlImg;
	}

	function imageSize(sizes, image) {
		if (image) {
			var desired_sizes = sizes.split(',');
			var supported_sizes = '';
			for (var k = 0; k < desired_sizes.length; k++) {
				var size = desired_sizes[k];
				var size_as_int = size * 1;
				if (image.width < size_as_int) { break; }
				supported_sizes = supported_sizes + size + ',';
			}

			if (supported_sizes == '') supported_sizes = image.width;

			if (!jQ.isNumeric(supported_sizes)) {
				supported_sizes = supported_sizes.split(',').join(',');
				supported_sizes = supported_sizes.substring(0, supported_sizes.lastIndexOf(','));
			}
			return supported_sizes;
		} else {
			return '';
		}
	}

	function buildPrice(data) {
		var html = '';
		var show_price_on_hover = boostPFSThemeConfig.custom.product_show_price_on_hover;
		var classPriceHover = show_price_on_hover ? 'ProductItem__PriceList--showOnHover' : '';
		html += '<div class="price-list">';
		if (onSale) {
			html += '<span class="h6 text-on-sale" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span> ';
			html += '<span class="h6 text-subdued line-through" data-money-convertible>' + Utils.formatMoney(data.compare_at_price_min) + '</span>';
		} else {
			if (priceVaries) {
				html += '<span class="h6 text-subdued">' + boostPFSThemeConfig.label.from.replace(/{{min_price}}/g, Utils.formatMoney(data.price_min)) + '</span>';
			} else {
				html += '<span class="h6 text-subdued" data-money-convertible>' + Utils.formatMoney(data.price_min) + '</span>';
			}
		}
		html += '</div>';
		return html;
	}

	//'More Colours' link when a product has multiple colour variants
	function buildMoreColoursLink(data) {
		var html = '';
		data.options.forEach(function (option, index) {
			option.toLowerCase();
			var option_index = index;
			var how_many_options = 0;
			var current_options = '';

			data.variants.forEach(function (variant, index) {
				var current_option = variant.options[option_index];
				if (!(current_options.includes(current_option))) {
					if (how_many_options > 0) {
						current_options = current_options.join('|').concat('|');
					}

					current_options = current_options.concat(current_option);
					current_options = current_options.split('|').sort();
					how_many_options = current_options.length;
				}

			});

			if (current_options.length > 1 && option.includes("colo")) {
				html += '<a href="{{itemUrl}}">' + '+ More Colours' + '</a>';
			}
		});
		return html;
	}

	function buildLabels(data) {
		var html = '';
		var product_labels = '';
		if (boostPFSThemeConfig.custom.show_labels) {
			product_labels = '';
			var tags = data.tags;
			for (var k = 0; k < tags.length; k++) {
				var tag = tags[k];
				if (tag.indexOf('__label') != -1) {
					product_labels += '<span class="badge badge--custom">' + tag.split('__label:')[1] + '</span>';
					break;
				}
			}
			if (!soldOut) {
				if (onSale)
					product_labels += '<span class="badge badge--on-sale">' + boostPFSThemeConfig.label.sale.replace('{{ savings }}', data.percent_sale_min +'%') + '</span>';
			} else {
				product_labels += ' <span class="badge badge--sold-out">' + boostPFSThemeConfig.label.sold_out + '</span>';
			}

			if (product_labels != '') {
				html += '<div class="badge-list badge-list--vertical">';
				html += product_labels;
				html += '</div>';
			}
		}
		return html;
	}

	function buildInfo(data, indx) {
		var html = '';
		if (boostPFSThemeConfig.custom.show_product_info) {
			var infoClass = (!boostPFSThemeConfig.custom.use_horizontal) ? 'ProductItem__Info--' + boostPFSThemeConfig.custom.product_info_alignment : '';
			html += '<div class="product-card__info empty:hidden">';
			html += '<div class="v-stack justify-items-center gap-2">';
			if (boostPFSThemeConfig.custom.show_vendor) {
				html += '<a href="' + Utils.buildProductItemVendorUrl(data.vendor) + '" class="vendor smallcaps heading">' + data.vendor + '</a>'
			}

			html += '<div class="v-stack justify-items-center gap-1">';
			html += '<a href="{{itemUrl}}" class="product-title h6 " data-instant="">' + data.title + '</a>';
			// html += '{{itemReviews}}';
			html += buildPrice(data);
			html += '</div>';
			html += '</div>';
			html += buildMoreColoursLink(data); //'More Colours' link when a product has multiple colour variants
			if (boostPFSThemeConfig.custom.show_color_swatch) {
				html += buildSwatch(data, indx);
			}
			html += '</div>';

			//WishListApp
            var hasOnlyDefaultVariant = (data.variants && data.variants.length === 1 && (!data.options_with_values || data.options_with_values.length === 0));
    		html += '<div class="osc-css wrapper-button-collection">';
    		html += '<div class="button-collection-wishlist button-' + data.id + '" ' +
    		        'data-product-id="' + data.id + '" ' +
    		        'data-has-only-variant="' + hasOnlyDefaultVariant + '" ' +
    		        'data-product-title="' + data.title + '">' +
    		        '<span class="button-icon"></span>' +
    		        '<span class="button-text"></span>' +
    		        '</div>' +
    		        '</div>';
    
    		// Optionally render product JSON and options if needed for your app
				/* ================= Helpers ================= */
				const A = v => (Array.isArray(v) ? v : []);
				const trim = s => (typeof s === 'string' ? s.trim() : s);
				const priceToCents = p => (p == null || p === '' ? null : Math.round(Number(p) * 100));

				// Keep JSON safe inside <script> and preserve \/ in titles
				function safeJSONStringify(obj) {
					return JSON.stringify(obj)
					.replace(/<\//g, '<\\/')
					.replace(/\u2028/g, '\\u2028')
					.replace(/\u2029/g, '\\u2029')
					.replace(/\//g, '\\/');
				}

				// ---------- display value helpers ----------
				function normLabel(s) {
					return String(s || '').toLowerCase().replace(/\s+/g, '').trim();
				}

				// From variant.original_merged_options like ["colour:Black Holmes","size:32"]
				function displayMapFromOriginalMergedOptions(v) {
					const map = {};
					const arr = Array.isArray(v?.original_merged_options) ? v.original_merged_options : [];
					for (const pair of arr) {
					const str = String(pair);
					const idx = str.indexOf(':');
					if (idx > -1) {
						const key = normLabel(str.slice(0, idx));
						const val = str.slice(idx + 1).trim();
						if (key && val) map[key] = val;
					}
					}
					return map;
				}

				function displayValueForIndex(v, i, productOptionNames) {
					const names = productOptionNames || [];
					const keyNorm = normLabel(names[i] || ('option' + (i + 1)));
					const map = displayMapFromOriginalMergedOptions(v);
					if (map[keyNorm]) return map[keyNorm];               // prefer display value
					const fallback = v['option' + (i + 1)];
					return fallback == null ? null : String(fallback);
				}

				function joinVariantTitleFromDisplay(v, productOptionNames) {
					const parts = [0,1,2].map(i => displayValueForIndex(v, i, productOptionNames))
					.filter(x => x !== null && x !== undefined && x !== '');
					return parts.join(' / ');
				}

				/* ================= Images & Media ================= */
				function buildImages(data) {
					const info = A(data.images_info).map(i => i?.src).filter(Boolean);
					const map  = data.images ? Object.values(data.images).filter(Boolean) : [];
					const list = info.length ? info : (map.length ? map : (data.featured_image ? [data.featured_image] : []));
					return Array.from(new Set(list));
				}

				function buildMedia(images) {
					return images.map((src, idx) => ({
					alt: null,
					id: null,
					position: idx + 1,
					preview_image: { aspect_ratio: 1.0, height: 1100, width: 1100, src },
					aspect_ratio: 1.0,
					height: 1100,
					media_type: 'image',
					src,
					width: 1100
					}));
				}

				/* ================= Option names & values ================= */
				function labelForOption(owv, i, fallback) {
					const o = A(owv)[i];
					return trim(o?.label || o?.name || o?.original_name || fallback || '');
				}

				function buildOptionNames(data) {
					if (Array.isArray(data.options) && data.options.length) {
					return data.options.map(trim);                      // e.g., ["Colour","Size"]
					}
					const owv = A(data.options_with_values);
					if (owv.length) return owv.map((_, i) => labelForOption(owv, i, null)).filter(Boolean);

					// infer by option1..3 presence
					const has = [false,false,false];
					A(data.variants).forEach(v => {
					if (v?.option1 != null) has[0] = true;
					if (v?.option2 != null) has[1] = true;
					if (v?.option3 != null) has[2] = true;
					});
					const out = [];
					if (has[0]) out.push('Option1');
					if (has[1]) out.push('Option2');
					if (has[2]) out.push('Option3');
					return out;
				}

				function buildOptionValuesForIndex(data, i) {
					const owv = A(data.options_with_values);
					const fromOwv = A(owv[i]?.values);
					if (fromOwv.length) {
					const vals = fromOwv.map(v => (typeof v === 'object' ? v.title : v)).filter(Boolean);
					return Array.from(new Set(vals));
					}
					const key = 'option' + (i + 1);
					const set = new Set();
					A(data.variants).forEach(v => {
					const val = v && v[key];
					if (val != null && val !== '') set.add(String(val));
					});
					return Array.from(set);
				}

				function buildOptionJson(data) {
					const names = buildOptionNames(data);
					return names.map((name, i) => ({
					name,
					position: i + 1,
					values: buildOptionValuesForIndex(data, i)
					}));
				}

				/* ================= Variants (display values in option1/2/3) ================= */
				function buildVariants(data, productTitle, optionNames) {
				const optionCount = Math.min(3, Math.max(1, optionNames.length || 1));

				return (Array.isArray(data.variants) ? data.variants : []).map(v => {
					// DISPLAY values aligned to product option names (e.g., "Black Holmes", "30")
					const disp1 = displayValueForIndex(v, 0, optionNames);
					const disp2 = displayValueForIndex(v, 1, optionNames);
					const disp3 = displayValueForIndex(v, 2, optionNames);
					const dispVals = [disp1, disp2, disp3];

					// Variant title from display values (e.g., "Black Holmes / 30")
					const title = [disp1, disp2, disp3].filter(x => x != null && x !== '').join(' / ');

					// Ensure options[] length matches option count and uses DISPLAY values
					const optionsArr = dispVals.slice(0, optionCount).map(x => (x == null ? '' : String(x)));

					return {
					id: v.id,

					// >>> Set option1/2/3 to DISPLAY values <<<
					option1: disp1 ?? null,
					option2: disp2 ?? null,
					option3: disp3 ?? null,

					// keep raw values too (if you still need them anywhere)
					option1_raw: v.option1 ?? null,
					option2_raw: v.option2 ?? null,
					option3_raw: v.option3 ?? null,

					title,                                        // escaped later → "Black Holmes \/ 30"
					sku: v.sku || '',
					requires_shipping: v.requires_shipping ?? false,
					taxable: v.taxable ?? false,
					featured_image: v.featured_image ?? null,
					available: !!v.available,
					name: (productTitle || '') + (title ? ' - ' + title : ''),
					public_title: title || null,
					options: optionsArr,                          // ["Black Holmes","30"]
					price: priceToCents(v.price),
					weight: v.weight ? Math.round(Number(v.weight) * 1000) : 0,
					compare_at_price: priceToCents(v.compare_at_price),
					inventory_management: v.inventory_management ?? 'shopify',
					barcode: v.barcode || '',
					featured_media: v.featured_media ?? null,
					requires_selling_plan: false,
					selling_plan_allocations: []
					};
				});
				}


				/* ================= Product Transformer ================= */
				function buildCleanProduct(data) {
					const images = buildImages(data);
					const featured = images[0] || null;
					const optionNames = buildOptionNames(data);            // e.g., ["Colour","Size"]
					const variants = buildVariants(data, data.title || '', optionNames);

					// Compute min/max in cents
					const prices = variants.map(v => v.price).filter(v => typeof v === 'number');
					const cmpPrices = variants.map(v => v.compare_at_price).filter(v => typeof v === 'number');
					const price_min = prices.length ? Math.min(...prices) : priceToCents(data.price_min);
					const price_max = prices.length ? Math.max(...prices) : priceToCents(data.price_max);
					const compare_at_price_min = cmpPrices.length ? Math.min(...cmpPrices) : priceToCents(data.compare_at_price_min);
					const compare_at_price_max = cmpPrices.length ? Math.max(...cmpPrices) : priceToCents(data.compare_at_price_max);

					return {
					id: data.id,
					title: data.title || '',
					handle: data.handle || '',
					//description: data.description || '',
					published_at: data.published_at || null,
					created_at: data.created_at || null,
					vendor: data.vendor || '',
					type: data.product_type || '',
					//tags: A(data.tags),

					// prices (cents)
					price: price_min ?? null,
					price_min,
					price_max,
					available: !!data.available,
					price_varies: price_min != null && price_max != null ? price_min !== price_max : false,

					compare_at_price: compare_at_price_min ?? null,
					compare_at_price_min,
					compare_at_price_max,
					compare_at_price_varies:
						(compare_at_price_min != null && compare_at_price_max != null)
						? compare_at_price_min !== compare_at_price_max
						: false,

					variants,
					images,
					featured_image: featured,
					options: optionNames,
					media: buildMedia(images),
					requires_selling_plan: false,
					selling_plan_groups: [],
					content: data.content || data.description || ''
					};
				}

				/* ================= Emit ================= */
				(function emitShopifyStyleJson(data) {
					const productJson = buildCleanProduct(data);
					html += '<script type="application/json" id="ProductJson-' + data.id + '">';
					html += safeJSONStringify(productJson);
					html += '</script>';

					const optionJson = buildOptionJson(data);
					html += '<script type="application/json" id="OptionJson-' + data.id + '">';
					html += safeJSONStringify(optionJson);
					html += '</script>';
				})(data);
 			
			//end WishListApp	          
		}

		return html;
	}

	function buildSwatch(data, indx) {
		var itemSwatchHtml = '';
		if (boostPFSThemeConfig.custom.show_color_swatch) {
			var color_name = boostPFSThemeConfig.custom.section_id + '-' + data.id + '-' + indx;
			data.options_with_values.forEach(function (option, index) {
				var option_name = option.name.toLowerCase();
				if (option_name.indexOf('color') != -1 || option_name.indexOf('colour') != -1 || option_name.indexOf('couleur') != -1) {
					var values = '';
					itemSwatchHtml += '<div class="ProductItem__ColorSwatchList">';
					var i = 0;
					data.variants.forEach(function (variant) {
						var temp = variant.merged_options.filter(function (obj) {
							obj = obj.toLowerCase();
							if (obj.indexOf('color') != -1 || obj.indexOf('colour') != -1 || obj.indexOf('couleur') != -1)
								return obj;
						});
						temp = temp[0].split(':');

						var value = temp[1].toLowerCase();
						if (values.indexOf(value) == -1) {
							values = values + ',' + value;
							values = values.split(',');
							var size = '200,400,600,700,800,900,1000,1200';
							var supported_sizes = imageSize(size, variant.image);
							var color_image = Utils.optimizeImage(variant.image);
							var name_color = Utils.slugify(value) + '.png';
							var checked = (i == 0) ? 'checked=checked' : '';
							var imageInfo = null;
							var image_aspect_ratio = 1;
							imageInfo = data.images_info.find(function (imageOb) {
								if (imageOb.src == variant.image) {
									image_aspect_ratio = imageOb.width / imageOb.height;
									return imageOb;
								}
							});
							if (!imageInfo) {
								if (data.images_info.length > 0) {
									imageInfo = data.images_info[0];
								} else {
									imageInfo = {
										src: boostPFSConfig.general.no_image_url,
										id: variant.id,
										width: 480,
										height: 480
									}
								}

							}
							var dataImg = (imageInfo != null) ? '" data-image-url="' + imageInfo.src + '" data-image-widths="[' + supported_sizes + ']" data-image-aspect-ratio="1" data-image-id="' + imageInfo.id + '"' : '';
							var color_input_id = color_name + "-" + values.length;
							var variant_price = variant.price ? variant.price : 0;
							var variant_compare_at_price = variant.compare_at_price ? variant.compare_at_price : 0;
							var url_color = Utils.getFilePath(Utils.slugify(value), Globals.swatchExtension, Settings.getSettingValue('general.swatchImageVersion'));
							itemSwatchHtml += '<div class="ProductItem__ColorSwatchItem">';
							itemSwatchHtml += '<input class="ColorSwatch__Radio" type="radio" ' + checked + ' name="' + color_name + '" id="' + color_input_id + '" value="' + value + '" data-image-aspect-ratio="' + image_aspect_ratio + '" data-variant-price="' + variant_price + '" data-variant-compare-at-price="' + variant_compare_at_price + '" data-variant-url="' + Utils.buildProductItemUrl(data) + '?variant=' + variant.id + '#Image' + imageInfo.id + '"' + dataImg + '  aria-hidden="true">';
							itemSwatchHtml += '<label class="ColorSwatch ColorSwatch--small" for="' + color_input_id + '" style="background-color: ' + value.replace(' ', '').toLowerCase() + '; background-image: url(' + url_color + ')" title="' + value + '" data-tooltip="' + value + '"></label>';
							itemSwatchHtml += '</div>';
							i++;
						}
					});
					itemSwatchHtml += '</div>';
				}
			});
		}
		return itemSwatchHtml;
	}
	/************************** END BUILD PRODUCT ITEM ELEMENTS **************************/
	/************************** BUILD TOOLBAR **************************/
	// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function (totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		if (totalPage > 1) {
			var paginationHtml = boostPFSTemplate.paginateHtml;
			// Build Previous
			var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
			previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
			paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);
			// Build Next
			var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
			nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
			paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);
			// Create page items array
			var beforeCurrentPageArr = [];
			for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
				beforeCurrentPageArr.unshift(iBefore);
			}
			if (currentPage - 4 > 0) {
				beforeCurrentPageArr.unshift('...');
			}
			if (currentPage - 4 >= 0) {
				beforeCurrentPageArr.unshift(1);
			}
			beforeCurrentPageArr.push(currentPage);
			var afterCurrentPageArr = [];
			for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
				afterCurrentPageArr.push(iAfter);
			}
			if (currentPage + 3 < totalPage) {
				afterCurrentPageArr.push('...');
			}
			if (currentPage + 3 <= totalPage) {
				afterCurrentPageArr.push(totalPage);
			}
			// Build page items
			var pageItemsHtml = '';
			var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
			for (var iPage = 0; iPage < pageArr.length; iPage++) {
				if (pageArr[iPage] == '...') {
					pageItemsHtml += boostPFSTemplate.pageItemRemainHtml;
				} else {
					pageItemsHtml += (pageArr[iPage] == currentPage) ? boostPFSTemplate.pageItemSelectedHtml : boostPFSTemplate.pageItemHtml;
				}
				pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
				pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, pageArr[iPage]));
			}
			paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);
			return paginationHtml;
		}

		return '';
	};

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function () {
		var html = '';
		if (boostPFSThemeConfig.custom.show_sorting && boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					var classActive = (Globals.queryParams.sort == k) ? 'is-selected' : '';
					sortingItemsHtml += '<button class="Popover__Value ' + classActive + ' Heading Link Link--primary u-h6" data-value="' + k + '">' + sortingArr[k] + '</button>';
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Sorting event
	ProductSorting.prototype.bindEvents = function () {
		var topSortingSelector = jQ(Selector.topSorting);
		topSortingSelector.find('.Popover__Value').click(function (e) {
			FilterApi.setParam('sort', jQ(this).data('value'));
			FilterApi.setParam('page', 1);
			FilterApi.applyFilter('sort');
			jQ('.CollectionToolbar__Item--sort').trigger('click');
		});
	}
	/************************** END BUILD TOOLBAR **************************/

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
		/**
		 *  Call theme function 
		 *  1. Add var bcPrestigeSections; var bcPrestigeSectionContainer; to assets/theme.min.js
		 *  2. In assets/theme.min.js, find var YYY=new XXX.SectionContainer; For example: var e=new o.SectionContainer;
		 *  3. Replace var e=new o.SectionContainer; by var e=new o.SectionContainer; var YYY = new XXX.SectionContainer;  bcPrestigeSections = YYY; bcPrestigeSectionContainer = XXX;
		
		if(typeof bcPrestigeSectionContainer != 'undefined' && typeof bcPrestigeSections != 'undefined'){
		bcPrestigeSections.register("collection", bcPrestigeSectionContainer.CollectionSection);
		bcPrestigeSections.register("search", bcPrestigeSectionContainer.SearchSection);
		}  
		*/

		// Append any featured collections that have order beyond product count
		if (typeof boostPFSThemeConfig !== 'undefined' && 
		    boostPFSThemeConfig.custom && 
		    boostPFSThemeConfig.custom.featured_collections && 
		    boostPFSThemeConfig.custom.featured_collections.length > 0 &&
		    data && data.products) {
			
			var featuredCollections = boostPFSThemeConfig.custom.featured_collections;
			var productCount = data.products.length;
			var productGrid = jQ(Selector.products);
			var filterPosition = boostPFSThemeConfig.custom.filter_position || 'drawer';
			var layoutClass = filterPosition == 'drawer' ? 'lap-and-up' : 'desk';
			var mobileRow = boostPFSThemeConfig.custom.mobile_row || '2';
			var tabletRow = boostPFSThemeConfig.custom.tablet_row || '3';
			var desktopRow = boostPFSThemeConfig.custom.desktop_row || '4';
			
			// Append featured collections that appear after all products
			featuredCollections.forEach(function(featured) {
				if (featured.order > productCount) {
					var featuredHtml = '<div class="Grid__Cell-assigned-featured-collection Grid__Cell 1/' + mobileRow + '--phone 1/' + tabletRow + '--tablet-and-up 1/' + desktopRow + '--' + layoutClass + '" style="order: ' + featured.order + '">';
					if (featured.image_url && featured.image_url !== 'null' && featured.image_url !== '') {
						var altText = (featured.title && featured.title !== 'null') ? featured.title : '';
						featuredHtml += '<img src="' + featured.image_url + '" alt="' + altText + '">';
					}
					featuredHtml += '<div class="featured-collection-content">';
					if (featured.title && featured.title !== 'null' && featured.title !== '') {
						featuredHtml += '<p>' + featured.title + '</p>';
					}
					if (featured.button_label && featured.button_label !== 'null' && featured.button_label !== '' && 
					    featured.button_url && featured.button_url !== 'null' && featured.button_url !== '') {
						featuredHtml += '<a href="' + featured.button_url + '"';
						if (featured.open_in_new_tab) {
							featuredHtml += ' target="_blank"';
						}
						featuredHtml += '>' + featured.button_label + '</a>';
					}
					featuredHtml += '</div></div>';
					
					productGrid.append(featuredHtml);
				}
			});
		}

		// Fix image not load on Instagram browser - initialize swatch image
		jQ(".ProductItem__Info .ProductItem__ColorSwatchList .ProductItem__ColorSwatchItem label.ColorSwatch").click(function () {
			jQ(this).parent().parent().find('label.ColorSwatch').removeClass('active');
			jQ(this).addClass('active');
			var parent = jQ(this).parent();
			var productImage = jQ(this).parent().parent().parent().parent().find('a.ProductItem__ImageWrapper');
			var variantInfo = parent.find('input.ColorSwatch__Radio');
			productImage.find('.AspectRatio .bc-sf-product-swatch-img').remove();
			productImage.find('.AspectRatio').prepend('<img class="bc-sf-product-swatch-img" src="' + variantInfo.data('image-url') + '" />');
			productImage.find('img.ProductItem__Image').hide();
			productImage.attr('href', variantInfo.data('variant-url'));
			var variantPrice = '';
			if (variantInfo.data('variant-compare-at-price') > variantInfo.data('variant-price')) {
				variantPrice += '<span class="ProductItem__Price Price Price--highlight Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>'
				variantPrice += '<span class="ProductItem__Price Price Price--compareAt Text--subdued" data-money-convertible="">' + Utils.formatMoney(variantInfo.data('variant-compare-at-price')) + '</span>';
			} else {
				variantPrice += '<span class="ProductItem__Price Price Text--subdued" data-money-convertible>' + Utils.formatMoney(variantInfo.data('variant-price')) + '</span>';
			}
			jQ(this).closest('.ProductItem__Wrapper').find('.ProductItem__PriceList').html(variantPrice);
		})

		//Change view layout
		var desktopView = jQ('.CollectionToolbar__LayoutSwitch.hidden-phone').find('.is-active').data('count');
		if (desktopView && desktopView != parseInt(boostPFSThemeConfig.custom.desktop_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.tablet_row + '--tablet-and-up 1/' + boostPFSThemeConfig.custom.desktop_row + '--' + buildClass());
			jQ(Selector.products + ' .Grid__Cell').addClass('1/' + desktopView + '--tablet-and-up 1/' + desktopView + '--' + buildClass());
		}
		var mobileView = jQ('.CollectionToolbar__LayoutSwitch.hidden-tablet-and-up').find('.is-active').data('count');
		if (mobileView && mobileView != parseInt(boostPFSThemeConfig.custom.mobile_row)) {
			jQ(Selector.products + ' .Grid__Cell').removeClass('1/' + boostPFSThemeConfig.custom.mobile_row + '--phone');
			jQ(Selector.products + ' .Grid__Cell').addClass('1/' + mobileView + '--phone');
		}
	};

	// Build additional elements
	FilterResult.prototype.afterRender = function (data, eventType) {
		if (!data) data = this.data;
		if (!eventType) eventType = this.eventType;
	};

	// Build Default layout
	Filter.prototype.errorFilterCallback = function () { var isiOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream, isSafari = /Safari/.test(navigator.userAgent), isBackButton = window.performance && window.performance.navigation && 2 == window.performance.navigation.type; if (!(isiOS && isSafari && isBackButton)) { var self = this, url = window.location.href.split("?")[0], searchQuery = self.isSearchPage() && self.queryParams.hasOwnProperty("q") ? "&q=" + self.queryParams.q : ""; window.location.replace(url + "?view=bc-original" + searchQuery) } };
})();